import { Amplify } from 'aws-amplify';
import { fetchAuthSession, signInWithRedirect, signOut } from 'aws-amplify/auth';
import { config } from './config';

// Every origin registered as a callback URL on the Cognito user-pool client.
// Keep in sync with `callbackUrls` in cdk/bin/x5-admin.ts — localhost is only
// registered there when the stack was deployed with `-c allowLocalDev=true`,
// so it is only offered here in a dev build.
const KNOWN_ORIGINS = [
  'https://x5admin.xiltrixusa.net',
  ...(import.meta.env.DEV ? ['http://localhost:5173'] : []),
];

// Amplify v6 picks the entry from redirectSignIn whose URL.origin === window.location.origin.
// Deriving from the live origin (plus the known list) makes one bundle work everywhere.
const currentOrigin =
  typeof window !== 'undefined' ? window.location.origin : KNOWN_ORIGINS[0]!;

const origins = Array.from(new Set([currentOrigin, ...KNOWN_ORIGINS]));
const redirectUrls = origins.flatMap((o) => [`${o}/`, o]);

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.cognitoUserPoolId,
      userPoolClientId: config.cognitoClientId,
      loginWith: {
        oauth: {
          domain: config.cognitoDomain,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: redirectUrls,
          redirectSignOut: redirectUrls,
          responseType: 'code',
        },
      },
    },
  },
});

export async function getIdToken(): Promise<string | null> {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() ?? null;
  } catch {
    return null;
  }
}

export async function signInWithGoogle(): Promise<void> {
  await signInWithRedirect({ provider: 'Google' });
}

export async function signOutEverywhere(): Promise<void> {
  await signOut({ global: true });
}
